import { typeAnniversaries } from "./anniversary"
import { queryAllAnniversaries } from "./queries/queryAllAnniversaries"
import { queryCustomerAnniversaries } from "./queries/queryCustomerAnniversaries"

const anniversarySchema = {
  types: [typeAnniversaries],
  resolvers: {
    Query: {
      ...queryAllAnniversaries,
      ...queryCustomerAnniversaries,
    },
    Mutation: {},
  },
}

export default anniversarySchema
